module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1138.16e15e48.png";